// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"236":"17fdf1de","266":"5358af8c","584":"23d23cfa","595":"b798a36f","602":"fff13544","868":"d26b401c","900":"c5d0e206"}[chunkId] + ".chunk.css";
};